export default __webpack_public_path__ + "static/media/phutram.b6168a28.png";